// extracted by mini-css-extract-plugin
export default {"termsContainer":"Terms_condition_termsContainer__NwKno"};